const initialState = {
  data:{},
  search:'',
  filter:[],
  sort:{
    field:'srvm_desc',
    asc:1
  }
};

export default (state = initialState, action = {}) => {
  switch(action.type) {
    case 'FETCH_SRVMS':
      return {
        ...state,
        data:  action.payload
      }
    case 'SORT_SRVMS':
      return {
        ...state,
        sort: action.sort
      }
    case 'SEARCH_SRVMS':
      return {
        ...state,
        search: action.search
      }
    case 'EDIT_SRVM':
      return {
        ...state,
        data: {
          ...state.data,
          [action.payload.srvm_id]:action.payload
        }
      }
    default: return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/srvms.js